<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DRCRIt/tc-custom/9781788636681.jpg?1730864230179" alt="This image is the cover for the book Putting on the Style, A Champion Street Market Saga"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Putting on the Style, A Champion Street Market Saga
      </h1>
      <p class="bookDescription body article font2">
        <p>  </p><p><b>A waitress worries she’s fallen for her brother’s killer in this moving saga of second chances and forbidden love set in 1950s Manchester.</b></p><p> Folk are just emerging from the shadow of WWII, and money is still tight. So the vibrant market of Champion Street is a source of many a tempting bargain—as well as all the local gossip. </p><p> Dena loves her Saturday job at Belle Garside’s market café, and her ready smile makes her a universal favourite. She is soon in thrall to Belle’s two good-looking and dangerous sons. But fate has other plans in store when her younger brother is killed by a gang of thugs.</p><p> Only when it is far too late does Dena begin to ask herself one terrifying question: has she fallen in love with her brother’s killer? </p><p><b>Perfect for fans of Kitty Neale and Ellie Dean.</b></p><p><b>Praise for <i>Putting on the Style</i> </b></p><p><b>“You can’t put a price on Freda Lightfoot’s stories from Manchester’s 1950s Champion Street Market. They bubble with enough life and colour to brighten up the dreariest day and they have characters you can easily take to your heart.” —<i>Northern Echo</i></b></p><p><b>“A rattling good read to touch the heart of anyone who has loved someone they shouldn’t have.” —<i>Dorset Evening Echo</i></b></p><p><b>“Deftly chronicled.” —<i>Telegraph &amp; Argus</i></b></p><b>“Freda Lightfoot’s talent for creating believable characters makes this a page-turning read.” —<i>Newcastle Evening Chronicle</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Freda Lightfoot
      </h2>
      
      <p class="authorDescription body article"><P><I>Sunday Times</I> bestselling author Freda Lightfoot was born in Lancashire. She has been a teacher, bookseller in the Lake District, then a smallholder and began her writing career publishing short stories and articles before finding her vocation as a novelist. She has since written over forty-eight novels, mostly sagas and historical fiction. She now spends warm winters living in Spain, and the rainy summers in Britain.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Digital Publishing Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?39dd4529